import { Button, Col, Divider, Flex, Form, FormInstance, FormProps, notification, Row, Upload } from "antd";
import ContaSelect from "../../../Conta/ContaSelect";
import { UploadOutlined } from "@ant-design/icons";
import { useObterLinkBoleto, useProcessarRetorno } from "../../../../../../Services/Financeiro/Titulo/Pagamento/BoletoServices";
import { forwardRef, useImperativeHandle } from "react";
import { PropriedadesDeNotificacao } from "../../../../../../Utils/Notificacoes";
import Boleto from "../../../../../../Models/Financeiro/Titulo/Pagamento/Boleto";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
export type BoletoBoletoObterLinkFormType = Boleto;

export interface IBoletoBoletoObterLinkFormProps extends Omit<FormProps<BoletoBoletoObterLinkFormType>, "onFinish"> {
    onSuccess?:(retorno:string, entrada:Boleto) => void;
    onCancelar?:() => void;
}

export interface IBoletoBoletoObterLinkFormRef extends FormInstance<BoletoBoletoObterLinkFormType> {

}

const BoletoBoletoObterLinkForm = forwardRef<IBoletoBoletoObterLinkFormRef, IBoletoBoletoObterLinkFormProps>(function BoletoBoletoObterLinkForm({
    form : formParam,
    onSuccess,
    onCancelar,
    ...rest
}, ref) {
    const [newForm] = Form.useForm<BoletoBoletoObterLinkFormType>();
    const form = formParam ?? newForm;

    const {
        mutate,
        isPending
    } = useObterLinkBoleto({
        onSuccess(retorno, boleto) {
            onSuccess?.(retorno, boleto);
        }
    });

    function cancelar() {
        form.resetFields();
        onCancelar?.();
    }

    return <Form<BoletoBoletoObterLinkFormType>
        ref={ref}
        form={form}
        layout="vertical"
        autoComplete="off"
        component={"div"}
        onFinish={mutate}
        {...rest}
    >
        <Row gutter={8} wrap>
            <Form.Item<BoletoBoletoObterLinkFormType> name={["codTitulo"]}></Form.Item>
            <Col xs={24}>
                <Form.Item<BoletoBoletoObterLinkFormType> label={"Conta"} name={["codConta"]} rules={[ { required : true } ]}>
                    <ContaSelect 
                        filtros={{
                            encerrada : false,
                            codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                        }}
                    />
                </Form.Item>
            </Col>

            <Col xs={24}>
                <Flex justify="space-between">
                    <Button type="primary" danger htmlType="button" size={"middle"} disabled={isPending} onClick={cancelar}>Cancelar</Button>
                    <Button type="primary" htmlType="button" onClick={form.submit} size={"middle"} loading={isPending}>Abrir</Button>
                </Flex>
            </Col>
        </Row>
    </Form>;
});

export default BoletoBoletoObterLinkForm;